import { useSelector } from 'react-redux';
import { prescriptionDefaults } from '../default/opsm/prescriptionDef';
export const usePrescriptionDefaults = () => {
  const flowPrescriptionDefaults = useSelector(
    (state: any) =>
      state?.workflow?.flowDefiningAttributes?.prescriptionDefaults
  );
  const basePrescriptionDefaults = useSelector(
    (state: any) => state.config?.prescriptionDefaults
  );
  if (flowPrescriptionDefaults) {
    const numericPrescriptionDefaults = Object.keys(
      flowPrescriptionDefaults
    ).reduce((acc, key) => {
      acc[key] = parseFloat(flowPrescriptionDefaults[key]);
      return acc;
    }, {});
    return numericPrescriptionDefaults;
  } else if (
    prescriptionDefaults &&
    window.rxcBrain?.config?.brand?.toLowerCase() === 'opsm'
  ) {
    return prescriptionDefaults;
  } else {
    return basePrescriptionDefaults;
  }
};
